module.exports = __webpack_public_path__ + "static/img/icon_jinhua_sr@2x.eb3948d7.png";